// PRC-032: tarjeta de indicador común (etiqueta, cifra, variación y nota),
// con los radios, bordes y jerarquía de las tarjetas de Overview.
import React from 'react';
import { Box } from '@mui/material';
import { J } from '../journeyTokens';

export type MetricTone = 'neutral' | 'up' | 'down';

const TONE_COLOR: Record<MetricTone, string> = { neutral: J.muted, up: '#34d399', down: '#fb7185' };

export interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  change?: React.ReactNode;
  changeTone?: MetricTone;
  note?: React.ReactNode;
  valueColor?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ label, value, change, changeTone = 'neutral', note, valueColor }) => (
  <Box sx={{ flex: 1, minWidth: 0, p: 2, borderRadius: '12px', border: '1px solid rgba(148,163,184,0.16)', bgcolor: 'rgba(15,23,42,0.58)', fontFamily: J.font }}>
    <Box sx={{ color: J.muted, fontSize: 12.5, fontWeight: 700 }}>{label}</Box>
    <Box sx={{ mt: '6px', color: valueColor ?? J.text, fontSize: 24, fontWeight: 800, lineHeight: 1.15, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums' }}>{value}</Box>
    {change && <Box sx={{ mt: '4px', color: TONE_COLOR[changeTone], fontSize: 12.5, fontWeight: 800, fontVariantNumeric: 'tabular-nums' }}>{change}</Box>}
    {note && <Box sx={{ mt: '4px', color: '#64748b', fontSize: 12 }}>{note}</Box>}
  </Box>
);

export default MetricCard;
